module.exports = __webpack_public_path__ + "static/media/Payments_Method.6e0c898c.svg";